import { createSlice } from "@reduxjs/toolkit";

const eventSlice = createSlice({
  name: "eventSlice",
  initialState: {
    shouldRefetchEventDetails: false
  },
  reducers: {
    triggerEventDetailsRefetch: (state) => {
      state.shouldRefetchEventDetails = true;
    },
    resetEventDetailsRefetch: (state) => {
      state.shouldRefetchEventDetails = false;
    }
  }
});
export const EVENT_SLICE = "eventSlice";
export const { triggerEventDetailsRefetch, resetEventDetailsRefetch } =
  eventSlice.actions;

export default eventSlice.reducer;
